import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get, isEmpty } from 'lodash';

import {
  newCheckInAction,
  newNextAction,
} from '../../actions/navigation';
import { useConfig } from '../../config/ConfigContext';
import Header from '../../components/Header';
import Tooltip from '../../components/Tooltip';
import Input from '../../components/Form/Input';
import Validator from '../../components/Validator';
import ApplicationId from '../../components/ApplicationId';
import Progress from '../../components/Progress';
import Button from '../../components/Button';
import Modal from '../../components/Modal';
import { addLusaHeaderParam, parseUrlParams } from '../../utils/parseUrlParams';
import { numberUnmask } from '../../utils/unmasks';
import schema from './schema';
import imgError from '../../assets/images/error.svg';

const Welcome = (props) => {
  const config = useConfig();
  const [isProgressVisible, setIsProgressVisible] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [uploadingPercentage, setUploadingPercentage] = useState(0);
  const { checkinData, navigate, validator: { values, errors } } = props;
  const match = useParams();
  const workflowType = get(match, 'workflowType') === 'luwa' ? 'dtm-luwa' : get(match, 'workflowType');

  useEffect(() => {
    const params = parseUrlParams(window.location.search);

    if (isEmpty(checkinData)) {
      props.newCheckInAction({
        workflowType,
        key: params.key,
        onUploadProgress: (progressEvent) => {
          setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
        },
        success: (res) => {
          let routeUrl = get(res, 'state.url', get(res, 'data.url')).replace(config.hostUrl, '');
          if (routeUrl && params.lusa_header && params.lusa_header === 'false') {
            routeUrl = addLusaHeaderParam(routeUrl.replace(config.hostUrl, ''));
          }
          navigate(routeUrl);
        },
      });
    }
  }, []);

  const handleSubmitForm = (e) => {
    e.preventDefault();
    const { validator: { validate } } = props;
    if (validate(schema).isValid) {
      const params = parseUrlParams(window.location.search);
      let formData;
      if (params.to) {
        formData = {
          SsnLast4Digits: numberUnmask(values.ssn),
          to: params.to,
        };
      } else {
        formData = {
          SsnLast4Digits: numberUnmask(values.ssn),
        };
      }
      setIsProgressVisible(true);
      props.newNextAction({
        workflowType,
        key: params.key,
        data: formData,
        onUploadProgress: (progressEvent) => {
          setUploadingPercentage(Math.floor((progressEvent.loaded * 100) / progressEvent.total));
        },
        success: (res) => {
          setIsProgressVisible(false);
          let routeUrl = get(res, 'state.url', '').replace(config.hostUrl, '');
          if (routeUrl && params.lusa_header && params.lusa_header === 'false') {
            routeUrl = addLusaHeaderParam(routeUrl.replace(config.hostUrl, ''));
          }
          navigate(routeUrl);
        },
        fail: (err) => {
          console.log(err);
          setIsPopupVisible(true);
          setIsProgressVisible(false);
        },
      });
    } else {
      console.log(errors);
      setIsPopupVisible(true);
      setIsProgressVisible(false);
    }
  };

  const handleInputChange = (event) => {
    const { validator: { onChangeHandler } } = props;
    onChangeHandler(event.target.name, event.target.value);
  };

  const handleClosePopup = () => {
    setIsPopupVisible(false);
  };

  return (
    <div className="transition-item wrapper v-center">
      <Header />
      {get(props.checkinData, 'attributes.entityId') ? (
        <ApplicationId id={get(props.checkinData, 'attributes.entityId')} style={{ marginTop: 10 }} />
      ) : null}
      <div className="content" style={{ minHeight: 'calc(100vh - 210px)' }}>
        <h2>
          Welcome back,
          {' '}
          {get(checkinData, 'state.data.firstName', '') || get(checkinData, 'data.data.firstName', '')}
          !
        </h2>
        <p>Please enter the last 4 of your SSN to verify your identity</p>
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="form-group active">
                <Input
                  label="Last 4 Digits of Your SSN"
                  value={values.ssn || ''}
                  name="ssn"
                  tooltip="To protect your identity and for security purposes please enter the last 4 digits of your Social Security Number."
                  isMasked={[/\d/, /\d/, /\d/, /\d/]}
                  onChange={handleInputChange}
                  type="tel"
                  isRequired
                  hasError={errors.ssn}
                />
                <Tooltip>To protect your identity and for security purposes please enter the last 4 digits of your Social Security Number.</Tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="footer">
        <div className="row">
          <div className="col">
            <Button
              className="btn arrow"
              onClick={handleSubmitForm}
              title="Continue"
              isDisabled={values.ssn === undefined}
            />
          </div>
        </div>
      </div>
      {
        isPopupVisible
          && (
          <Modal>
            <div className="card-content error-modal security-error">
              <img src={imgError} alt="" />
              <p>Please try again.</p>
              <div onClick={handleClosePopup} className="btn btn-red">OK</div>
            </div>
          </Modal>
          )
      }
      {
        isProgressVisible && <Progress percent={uploadingPercentage} />
      }
    </div>
  );
};

Welcome.propTypes = {
  navigate: PropTypes.func.isRequired,
  validator: PropTypes.object.isRequired,
  checkinData: PropTypes.object.isRequired,
  newCheckInAction: PropTypes.func.isRequired,
  newNextAction: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  fetch: state.fetch,
  checkinData: state.screen.checkinData,
});

const mapDispatchToProps = {
  newCheckInAction,
  newNextAction,
};

export default Validator(schema)(connect(
  mapStateToProps,
  mapDispatchToProps
)(Welcome));
